require('dotenv').config();
const keyCloackDbType: any = String(process.env[`APP_KEYCLOAK_DB_TYPE`]) || 'mysql';
const kafkaBrokers: string[] = [process.env[`KAFKA_BROKER`]];
const dBType:any=process.env[`APP_DB_TYPE`] || 'mongo';
export const jobConfigs = {
  port: parseInt(process.env[`APP_SERVER_PORT`]) || 3339,
  loggingMode: process.env[`APP_LOGGING_MODE`] || 'error',
  database: {
    type: dBType,
    host: process.env[`APP_DB_HOST`],
    port: parseInt(process.env[`APP_DB_PORT`]) || 5432,
    username: process.env[`APP_DB_USER`] || 'postgres',
    password: process.env[`APP_DB_PASS`] || 'devpgsql',
    dbName: process.env[`APP_DB_DBNAME`] || 'rfj',
    poolLimit: parseInt(process.env[`APP_DB_POOL_LIMIT`]) || 50
  },
  keycloak: {
    keycloakUrl: process.env[`APP_KEYCLOAK_AUTH_URL`],
    keycloakRealm: process.env[`APP_KEYCLOAK_REALM`],
    keycloakClientId: process.env[`APP_KC_CLIENT`] || 'oms-back-end',
    keycloakSecretKey: process.env[`APP_KC_SECRET`],
    keycloakDB: process.env[`APP_KEYCLOAK_DB`] || 'keycloak',
    keycloakDBType: keyCloackDbType,
    keycloakDBHost: process.env[`APP_KEYCLOAK_DB_HOST`],
    keycloakDBPort: parseInt(process.env[`APP_KEYCLOAK_DB_PORT`]),
    keycloakDBUser: process.env[`APP_KEYCLOAK_DB_USER`],
    keycloakDBPass: process.env[`APP_KEYCLOAK_DB_PASS`],
  }, 
  swagger: {
    basePath: process.env[`APP_SWAGGER_BASE_PATH`] || 'function/job-management-api/'
  },
  responseTimeOut: parseInt(process.env[`APP_RESPONSE_TIME_OUT`]) || 600,
  arenaConfig: {
    basePath: process.env[`ARENA_BASE_PATH`] || 'function/job-management-api/'
  },
  redis: {
    host: process.env[`REDIS_HOST`],
    port: parseInt(process.env[`REDIS_PORT`]),
    password: process.env[`REDIS_PASSWORD`],
  },
  bullJobOptions: {
    //removeOnComplete: true,
    //removeOnFail: true,
    attempts: 1
  },
  bullAdvancedSettings: {
    lockDuration: 300000,
    stalledInterval: 300000,
    maxStalledCount: 1,
    guardInterval: 5000,
    retryProcessDelay: 5000,
    drainDelay: 5, // Wait time for brpoplpush in empty queue
  },
  kafka: {
    clientId: process.env.KAFKA_CLIENT_ID || 'SFCS-N',
    groupId: process.env.KAFKA_GROUP_ID || 'SFCS-PTS',
    brokers: kafkaBrokers,
  }
}

export default jobConfigs;
